import React from "react";
import composedIdentityDoc from "../../../containers/IdentityDocumentContainer";
import IdentityDocument from "./IdentityDocument";

const IdentityDocumentMainContainer = (props) => {
  return <IdentityDocument />;
};

export default composedIdentityDoc(IdentityDocumentMainContainer);
